module.exports = __webpack_public_path__ + "img/nature.1695735a.jpg";